/**
 * Improve scrolling performance with passive listeners
 * https://developers.google.com/web/updates/2016/06/passive-event-listeners
 */
 (window as any).__zone_symbol__PASSIVE_EVENTS = ['scroll', 'touchstart'];

 /**
  * Resizing the window does not trigger change-detection
  */
 (window as any).__zone_symbol__UNPATCHED_EVENTS = ['resize'];